import React, { Component, Children } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

class Strip extends Component {
  static propTypes = {};

  render() {
    const { children, display } = this.props;
    return (
      <div className={cx(styles.strip, styles[display])}>
        {Children.map(children, child => (
          <div className={styles.child}>{child}</div>
        ))}
      </div>
    );
  }
}

Strip.defaultProps = {
  display: "column"
};

Strip.propTypes = {
  children: PropTypes.node,
  display: PropTypes.oneOf(["row", "column"])
};

export default Strip;



// WEBPACK FOOTER //
// ./src/components/common/Strip/Strip.js